import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// For further development convert the object in the init function to JSON file.
i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
          pages:{
            home:{
              hero: {
                header:{
                  title0: "Meet ",
                  title1: "Meet Cere",
                  title2: "Your All-in-One Guide",
                  title3: "to Knowledge, Creativity and Fun",
                  title4: "Cere",
                  title5: "",
                  title6: "",
                  title7: "GET IT ON", 
                  title8: "Download on", 
                  title9: "Access on",
                  title10: "Web",
                },
                description1: "Bring a dose of intelligence and humor to your daily routine.",
                description2: "Hunt for the latest tech trends.",
                description3: "Constantly learning and exploring",
              },
              features:{
                header:{
                  title: "Cere is with you everywhere",
                  description: "Let’s Discuss Business, Science, Art, Games and Everything in Between."
                },
                feature1:{
                  title:"Natural Language Processing",
                  description:"You can communicate with Cere like you're talking to your friends"
                },
                feature2:{
                  title:"Multilingual Support",
                  description:"Cere can understand more than 5 languages.​"
                },
                feature3:{
                  title:"Report via E-Mail",
                  description:"Cere can send the work you created to your e-mail adress​"
                },
                feature4:{
                  title:"Unique Responses ",
                  description:"Each and every response you get from Cere is unique to you​"
                },
                feature5:{
                  title:"Analytics and Reporting",
                  description:"Cere can provide analytics and reporting on user interactions, engagement rates, and other metrics.​"
                },
                feature6:{
                  title:"Security and Privacy",
                  description:"The app is designed with robust security and privacy features to protect user data and prevent unauthorized access.​"
                },
                questions:{
                  q1:"What are the top 10 tourist destinations in the world?",
                  q2:"How can I improve my writing skills for academic or professional purposes?",
                  q3:"What are the best ways to start a successful online business?",
                  q4:"What are some easy and healthy meal prep ideas?",
                  q5:"How can I improve my photography skills?",
                  q6:"What are the most popular fashion trends for the summer season?"
                }
              },
              statistics:{
                header: {
                  title: "Productivity Tool",
                  description:"CereMeet provides a highly customizable 3D environment that enable users to express them selves in the metaverse."
                },
                stats:{
                  text1:"Downloads",
                  text2:"Corporate Customers",
                  text3:"Spent in Chats",
                  text4:"Conversation Created",
                }
              },
              gallery:{
                header: {
                  title: "Out of Box Meetings",
                  description:"No need to feel boxed in just one small meeting room! In Cere, we have three different meeting rooms and one big meeting hall area that you can customize to your heart's content. Create your virtual twin yourself and start your meeting now!"
                },
              },
              pricing:{
                header: {
                  title: "Pricing",
                  description:"Choose one of our membership packages below and start experiencing Cere!"
                },
                card1:{
                  header:{
                    title1: "Start",
                    title2: "Free"
                  },
                  items:{
                    text1:"Ask up to 15 Questions without Ads ",
                    text2:"Text and Voice Chat Options ",
                    text3:"",
                  }
                },
                card2:{
                  header:{
                    text1:"PRO",
                    title1: "MONTHLY",
                    title2: "/mo"
                  },
                  items:{
                    text1:"Unlimited Access and Access on Multiple Devices Simultaneously. ",
                    text2:"Text And Voice Chat Options ",
                    text3:"Daily News Summary Provider",
                    text4:"Priority Support: More Accurate and Faster Responses ",
                    text5:"Buy Now",

                  }
                },
                card3:{
                  header:{
                    title1: "ANNUAL",
                    title2: "/yr"
                  },
                  items:{
                    text1:"Unlimited Access and Access on Multiple Devices Simultaneously. ",
                    text2:"Text And Voice Chat Options ",
                    text3:"Daily News Summary Provider",
                    text4:"Priority Support: More Accurate and Faster Responses ",
                    text6:"Buy Now",
                  }
                },
                card4:{
                  header:{
                    title1: "CONTACT US",
                    title2: "Enterprise"
                  },
                  items:{
                    text1:"Unlimited Access and Access on Multiple Devices Simultaneously. ",
                    text2:"Text And Voice Chat Options ",
                    text3:"Daily News Summary Provider",
                    text4:"Priority Support: More Accurate and Faster Responses ",
                    text5:"Analytics and Reporting ",
                  }
                },
                refund:{
                  text1: "You can get your full refund if you decide to cancel your subscription within 72 hours after your first purchase."
                }
              },
              contact:{
                header: {
                  title: "Contact Us",
                  description:"For further questions, please send us a message. Our team will get back to you within 24 hours."
                },
              }
            },
            faq:{
              text1:"Frequently Asked Questions",
              text2:"Enterprise",
            },
            payment:{
              header:{
                item1:{
                  text1: "Subscription",
                  text2: "First Step",
                },
                item2:{
                  text1: "User Info",
                  text2: "Second Step",
                },
                item3:{
                  text1: "Address",
                  text2: "Third Step",
                },
                item4:{
                  text1: "Purchase",
                  text2: "Final Step",
                },
              },
              form1:{
                text1:"Monthly",
                text2:"Annual",
                text3:"Subscription",
              },
              form2:{
                text1:"Fullname",
                text2:"VAT Number",
                text3:"GSM Number",
                text4:"Country",
                placeholder4: "Spain",
                validation:{
                  input1:"Please enter your name!",
                  input3:"Please enter your GSM Number!",
                  input3reg:"Type your number without + or any space",
                  input4:"Please enter your country!",
                  input5:"",
                }
              },
              form3:{
                section1:{
                  text1: "Select Existing Address",
                  text2: "Pick Address",
                },
                section2:{
                  text1: "Address Name",
                  text2: "Address",
                  text3: "Country",
                  text4: "City",
                  text5: "Zip Code",
                  text6: "New Address",
                  text7: "Add Address",
                  placeholder1: "Home",
                  placeholder3: "Turkey",
                  validation:{
                    input1:"Please enter address name!",
                    input1min:"Address name must be at least 3 character",
                    input1max:"Address name must be at most 20 character",

                    input2:"Please enter address text!",
                    input2min:"Address text must be at least 3 character ",
                    input2max:"Address text must be at most 60 character",
                    
                    input3:"Please enter your city!",
                    input3min:"City must be at least 3 character!",
                    input3max:"City must be at most 20 character",
                   
                    input4:"Please enter your country!",
                    input4min:"Country must be at least 3 character ",
                    input4max:"Country must be at most 20 character",
                   
                    input5:"Please enter your Zip code!",
                    input5min:"Zip code must be at least 5 character !",
                    input5max:"Zip code must be at most 5 character !!",
                    input6:"",
                  }
                }
              },
              form4:{
                text1: "Cardholder Name",
                text2: "Card Number",
                text3: "Expire Year",
                text4: "Expire Month",
                text5: "CVC",
                btn: "Buy",
                validation:{
                  input1:"Please enter Cardholder name!",
                  input1min:"Cardholder name must be at least 2 character",

                  input2:"Please enter card number!",
                  
                  input3:"Please enter your expire month!",
                  input3min:"Expire month must be at least 2 character!",
                  input3max:"Expire month must be at most 2 character",
                 
                  input4:"Please enter your expire year!",
                  input4min:"Expire year must be at least 2 character ",
                  input4max:"Expire year must be at most 2 character",
                 
                  input5:"Please enter your cvc!",
                  input5min:"Cvc must be at least 3 character !",
                  input5max:"Cvc must be at most 3 character !!",
                  input6:"",
                }
              },
              completed:{
                text1: "Purchase completed!",
                text2:"You can access premium features of Cere."
              },
              card:{
                text1: "My Card",
                text2: "Total"
              },
              btn: "Next"
            },
            pagenotfound:{},
          },
          components:{
            forms:{
              login:{
                header: "Login to Cere",
                inputEmail: "Email",
                inputPwd: "Password",
                placeholder1:"Your Password",
                text1: "Remember me",
                text2: "Forgot password?",
                text3: "Do not have an account yet?",
                text4: "Create account",
                button:{
                  btnSubmit: "Log in",
                  btnGoogle: 'Sign in with Google',
                },
                validation:{
                  input1:"Please enter your email address!",
                  input1format:"Email format is not correct!",
                  input2:"Please enter your password!",
                  input2min:"Your password must be at least 8 characters",
                  input2max:"Your password must be at most 25 characters",
                  input3:"",
                }
              },
              register:{
                header: "Sign up to Cere",
                inputEmail: "Email",
                inputName: "Fullname",
                inputPwd: "Password",
                inputConPwd: "Confirm Password",
                placeholder1: "Your Password",
                placeholder2: "Re-enter password",
                button:{
                  btnSubmit: "Sign up",
                  btnGoogle: "Sign up with Google"
                },
                validation:{
                  input1:"Please enter your name!",
                  input2:"Please enter your email address!",
                  input2format:"Email format is not correct!",
                  input3:"Please enter your password!",
                  input3min:"Your password must be at least 8 characters",
                  input3max:"Your password must be at most 25 characters",
                  input4:"Please re-enter your password",
                  input5:"Passwords do not match!",
                  input6:"",
                }
              },
              forgot:{
                
                header: "Get Recovery Code",
                inputEmail: "Email",
                inputPwd: "Password",
                inputConPwd: "Confirm Password",
                placeholder1: "Your Password",
                placeholder2: "Code",
                button:{
                  btnSubmit: "Submit",
                },
                header2: "Reset Password",
                text1: "Reset Password",
              },
              contact:{
                text1:"Name",
                text2:"Email",
                text3:"Message",
                text4:"Your Message",
                button:"Submit",
                validation:{
                  input3:"Please enter your message!"
                }
              },
            },
            secondHero:{
              header:{
                title: "CereMeet is a productivity and communication platform in the metaverse.",
                description: "CereMeet gathers the capabilities of traditional communication platforms in a highly realistic 3D environment with photorealistic avatars.",
                button:{
                  btnSubmit: "Get Started",
                }
              }
            },
            navbar:{
              main:{
                text1:"Pricing",
                text2:"Contact Us",
                text3:"FAQ",
                text4:"Guideline",
                text5:"CereMeet",
                link: "https://pdate.ceremeet.com/ceremeetPictures/pdf/Cere_Guideline.pdf"
              },
              right:{
                text1:"Log in",
                text2:"Sign up"
              },
              drawer:{
                text1: "Home",
                text2: "Pricing",
                text3: "Contact Us",
                text4: "FAQ",
                text5: "Guideline",
                link: "https://pdate.ceremeet.com/ceremeetPictures/pdf/Cere_Guideline.pdf"
              },
              modal1:{
                text1: "You are going to downgrade your Cere account.",
                text2: "Are you sure?",
                text3: "Remove Subscription",
                btn1: "Unsubscribe",
                btn2: "Back",
              },
              modal2:{
                text1: "To buy Cere products",
                text2: "You need to login!",
                text3: "Please Login",
                btn1: "Login",
                btn2: "Back",
              },
              profile:{
                text1: "Loading...",
                text2: "To access your profile, please log in!",
                btn1: "Manage Membership",
                btn2: "Update Password",
                btn3: "Log Out",
                btn4: "Unsubscribe ",
                btn5: "Back",
              },
              popover1:{
                text1 :"There are no items selected!",
                btn1 :"Purchase Now",
              }
            },
            footer:{
              text1:"Privacy Policy"
            },
            errors:{
              title: "Error",
              404: "Page cannot be found",
              1001: "Address with that ID not found",
              1002:"You are not authorized to delete this address",
              1003:"You are not authorized to display this address",
              1004:"Address with that name already exist",
              1005:"Address with that title already exist",
              1101:"Validation error",
              2001:"Invalid email or password",
              2002:"You are not verified, check your email to verify your account",
              2003:"Invalid email or password",
              2004:"Invalid email",
              2006:"Could not verify email",
              2007:"Could not refresh access token",
              2008:"User with that email already exist",
              2009:"Your password reset code is not valid.",
              3001:"There was an error sending email, please try again",
              4001:"Meeting with that ID not found",
              5001:"AI quota exceeded",
              5002:"Conversation limit exceeded",
              5003:"Bot with that ID not found",
              5004:"AI response error",
              5005:"The question violates our terms of service",
              6001:"User with that ID not found",
              6002:"Username already exists",
              7001:"You are not logged in",
              7002:"Invalid token or user doesn't exist",
              7003:"Invalid token or session has expired",
              7004:"Session has expired or user doesn't exist",
              9001:"You already have a subscription",
              9002:"You dont have a subscription",
              100001:"System error",
              100310:"Invalid token.",
              100311:"Access token expired.",
              100312:"Authentication error.",
              100300:"You do not have access to merchant information.",
              200301:"Email is required.",
              200302:"Email should include less than {0} characters.",
              200303:"Email format is invalid.",
              200304:"Identity number is required.",
              200305:"Identity number should include less than {0} characters.",
              200306:"Identity number should include more than {0} characters.",
              200310:"Phone number is invalid.",
              200311:"Phone number should include less than {0} characters.",
              200320:"Pagination request not valid.",
              200500:"Product name is required.",
              200501:"At least one parameter is required.",
              200600:"Pricing plan name is required.",
              200601:"Pricing plan price is required.",
              200602:"Pricing plan price is invalid.",
              200603:"Payment Interval is required.",
              200604:"Payment Interval is invalid.",
              200605:"currencyCode is required.",
              200606:"PlanPaymentType is required",
              200607:"PlanPaymentType is invalid",
              200608:"Trial period is invalid.",
              200610:"Reference code is required.",
              200611:"Payment interval count is invalid.",
              200700:"Customer name is required.",
              200701:"Customer surname is required.",
              200702:"Customer phone number is required.",
              200703:"Billing address is required.",
              200710:"At least one parameter is required.",
              200711:"Reference code is required",
              200800:"Address is required.",
              200801:"Address should include less than {0} characters.",
              200802:"Contact Name is required.",
              200803:"Contact Name should include less than {0} characters.",
              200804:"City is required.",
              200805:"City should include less than {0} characters.",
              200806:"Country is required.",
              200807:"Country should include less than {0} characters",
              200808:"Zip Code should include less than {0} characters.",
              200900:"Reference code is required.",
              200901:"Reference code is required.",
              200902:"Subscription status is invalid.",
              201550:"Price is required.",
              201551:"Price should be more than zero.",
              201000:"Product is not found.",
              201001:"Product already exists.",
              201002:"Active product is not found.",
              201500:"Pricing plan is not found.",
              201501:"Pricing plan already exists.",
              201052:"Active pricing plan is not found",
              201053:"Pricing plan is not suitable to be deleted",
              201054:"Pricing plan is not active.",
              201100:"Customer is not found.",
              201101:"Customer already exists.",
              201102:"Customer is not active.",
              201103:"Customer should have card.",
              201400:"Subscription is not found.",
              201401:"Subscription is not allowed to activate.",
              201402:"Subscription is not allowed to upgrade.",
              201403:"Subscription is not allowed to cancel.",
              201404:"Subscription has already same pricing plan.",
              201405:"Subscription upgrade is not allowed to different product.",
              201406:"Subscription can not be upgraded to a pricing plan with different payment interval.",
              201450:"Subscription order is not found.",
              200750:"Card is required",
              200751:"Card should be allowed to be registered.",
              200903:"Subscription reference code is required.",
              200905:"Subscription status is invalid for card update.",
              201552:"Debit card is not supported.",
              201553:"Card is not belong to customer.",
              201451:"Subscription payment not suitable for retry.",
              201600:"Checkoutform is not found.",
              201601:"Checkoutform not completed.",
              201700:"Recurring payment attempt not found!",
              201900:"Currency is not found.",
            },
            successes:{
              title:"Success",
              payment:{
                text1:"Profile info updated.",
                text2:"Address info updated.",
                text3:"Payment received.",
              },
              login:{
                text1:"You are logged in."
              },
              register:{
                text1:"Profile created."
              },
              forgot:{
                text1:"Renewal code sent to your email address.",
                text2:"Your password has been renewed."
              },
              contact:{
                text1:"Message received."
              }
            }
          }
        }
      },
      // TURKISH SECTION
      tr: {
        translation: {
          pages:{
            home:{
              hero: {
                header:{
                  title0: "",
                  title1: "",
                  title2: "Hepsi Bir Arada Arkadaşınız",
                  title3: "",
                  title4: "Cere",
                  title5: " ile Tanışın",
                  title6: "Bilgi, Yaratıcılık ve Eğlence için ",
                  title7: "Hemen indir", 
                  title8: "Hemen indir",
                  title9: "Hemen başla",
                  title10: "Web",
                },
                description1: "Günlük rutininize bir doz zeka ve mizah getirin.",
                description2: "En son teknoloji trendlerini araştırın.",
                description3: "Sürekli öğrenme ve keşfetme",
              },
              features:{
                header:{
                  title: "Cere her yerde sizinle!",
                  description: "Hadi Bilimi, Sanatı, Gündemi, Oyunları ve Daha Pek Çok Konuyu Tartışalım "
                },
                feature1:{
                  title:"Doğal Dil İşleme (NLP) Yetenekleri",
                  description:"Kullanıcılar Cere ile günlük konuşma dili ile sohbet edebilir, "
                },
                feature2:{
                  title:"Çoklu Dil Desteği",
                  description:"Cere 5'ten fazla dili anlayabilir.​"
                },
                feature3:{
                  title:"E-Posta ile Raporlama",
                  description:"Cere ile birlikte oluşturduğunuz içeriklerinizi mail yolu ile gönderebilirsiniz.​"
                },
                feature4:{
                  title:"Kişiye Özel Cevaplama",
                  description:"Yanıtları kişiselleştirin ve kullanıcı deneyimini iyileştirin.  Cere özel ihtiyaçları ve tercihleri karşılamak için özelleştirilebilir ve eğitilebilir.​"
                },
                feature5:{
                  title:"Kurumsal Müşteriler İçin Analiz ve Raporlama ",
                  description:"Cere kullanıcı etkileşimleri, etkileşim oranları ve diğer metrikler hakkında analiz ve raporlama sağlayabilir. ​"
                },
                feature6:{
                  title:"Güvenlik ve Gizlilik",
                  description:"Uygulama, kullanıcı verilerini korumak ve yetkisiz erişimi önlemek için güçlü güvenlik ve gizlilik özellikleriyle tasarlanmıştır.​"
                },
                questions:{
                  q1:"Dünya genelinde en popüler turistik yerler hangileridir? ",
                  q2:"Akademik veya profesyonel amaçlar için yazma becerimi nasıl geliştirebilirim? ",
                  q3:"Başarılı bir online işletme nasıl kurulur? ",
                  q4:"Kolay ve sağlıklı yemek hazırlama fikirleri nelerdir? ",
                  q5:"Fotoğrafçılık becerilerimi nasıl geliştirebilirim? ",
                  q6:"Yaz sezonu için en popüler moda trendleri nelerdir?"
                }
              },
              statistics:{
                header: {
                  title: "Productivity Tool",
                  description:"CereMeet provides a highly customizable 3D environment that enable users to express them selves in the metaverse."
                },
                stats:{
                  text1:"Downloads",
                  text2:"Corporate Customers",
                  text3:"Spent in Chats",
                  text4:"Conversation Created",
                }
              },
              gallery:{
                header: {
                  title: "Out of Box Meetings",
                  description:"No need to feel boxed in just one small meeting room! In Cere, we have three different meeting rooms and one big meeting hall area that you can customize to your heart's content. Create your virtual twin yourself and start your meeting now!"
                },
              },
              pricing:{
                header: {
                  title: "Fiyatlandırma",
                  description:"Aşağıdaki üyelik paketlerimizden birini seçin ve CereMeet'i deneyimlemeye başlayın!"
                },
                card1:{
                  header:{
                    title1: "BAŞLANGIÇ",
                    title2: "Ücretsiz"
                  },
                  items:{
                    text1:"Reklamsız 15 soruya kadar soru sorma imkanı ",
                    text2:"Yazılı ve Sesli Sohbet Seçenekleri",
                    text3:"",
                  }
                },
                card2:{
                  header:{
                    text1:"PRO",
                    title1: "AYLIK",
                    title2: "/ay"
                  },
                  items:{
                    text1:"Sınırsız erişim + aynı anda birden fazla cihazdan erişim ",
                    text2:"Yazılı ve Sesli Sohbet Seçenekleri ",
                    text3:"Günlük Haberlerin Özeti ",
                    text4:"Öncelikli Destek: Daha Doğru ve Daha Hızlı Yanıtlar ",
                    text5:"Satın Al",
                  }
                },
                card3:{
                  header:{
                    title1: "YILLIK",
                    title2: "/yıl"
                  },
                  items:{
                    text1:"Sınırsız erişim + aynı anda birden fazla cihazdan erişim ",
                    text2:"Yazılı ve Sesli Sohbet Seçenekleri ",
                    text3:"Günlük Haberlerin Özeti ",
                    text4:"Öncelikli Destek: Daha Doğru ve Daha Hızlı Yanıtlar ",
                    text6:"Satın Al",
                  }
                },
                card4:{
                  header:{
                    title1: "BİZE ULAŞIN",
                    title2: "Kurumsal"
                  },
                  items:{
                    text1:"Sınırsız erişim + aynı anda birden fazla cihazdan erişim ",
                    text2:"Yazılı ve Sesli Sohbet Seçenekleri ",
                    text3:"Günlük Haberlerin Özeti ",
                    text4:"Öncelikli Destek: Daha Doğru ve Daha Hızlı Yanıtlar ",
                    text5:"Analiz ve Raporlama ",
                  }
                },
                refund: {
                  text1: "İlk satın alma işleminizden sonraki 72 saat içerisinde aboneliğinizi iptal etmeye karar verirseniz, paranızın tamamını geri alabilirsiniz."
                }
              },
              contact:{
                header: {
                  title: "Bize Ulaşın",
                  description:"Diğer sorularınız için bizlere mesaj gönderebilirsiniz. Ekibimiz size 24 saat içerisinde dönüş yapacaktır."
                },
              }
            },
            faq:{
              text1:"Sık Sorulan Sorular",
              text2:"Kurumsal",
            },
            payment:{
              header:{
                item1:{
                  text1: "Üyelik",
                  text2: "İlk Adım",
                },
                item2:{
                  text1: "Kullanıcı Bilgileri",
                  text2: "İkinci Adım",
                },
                item3:{
                  text1: "Adres",
                  text2: "Üçüncü Adım",
                },
                item4:{
                  text1: "Alım",
                  text2: "Son Adım",
                },
              },
              form1:{
                text1:"Aylık ",
                text2:"Yıllık ",
                text3:"Üyelik",
              },
              form2:{
                text1:"Tam Ad",
                text2:"TC Kimlik Numarası",
                text3:"Telefon Numarası",
                text4:"Ülke",
                placeholder4: "İspanya",
                validation:{
                  input1:"Lütfen adınızı giriniz!",
                  input3:"Lütfen telefon numaranızı giriniz!",
                  input3reg:"Numaranızı + veya boşluk olmadan yazın",
                  input4:"Lütfen ülkenizi girin!",
                  input5:"",
                }
              },
              form3:{
                section1:{
                  text1: "Kayıtlı Adreslerden Seç",
                  text2: "Adres Seç",
                },
                section2:{
                  text1: "Adresiniz",
                  text2: "Tam Adres",
                  text3: "Ülke",
                  text4: "Şehir",
                  text5: "Zip Kodu",
                  text6: "Yeni Adres Ekle",
                  text7: "Adres Ekle",
                  placeholder1: "Ev",
                  placeholder3: "Turkiye",
                  validation:{
                    input1:"Lütfen adres adını giriniz!",
                    input1min:"Adres adı en az 3 karakter olmalıdır",
                    input1max:"Adres adı en fazla 20 karakter olmalıdır",

                    input2:"Lütfen adres metnini giriniz!",
                    input2min:"Adres metni en az 3 karakter olmalıdır",
                    input2max:"Adres metni en fazla 60 karakter olmalıdır",
                   
                    input3:"Lütfen şehrinizi giriniz!",
                    input3min:"Şehir en az 3 karakter olmalıdır!",
                    input3max:"Şehir en fazla 20 karakter olmalıdır",
                  
                    input4:"Lütfen ülkenizi girin!",
                    input4min:"Ülke en az 3 karakter olmalıdır",
                    input4max:"Ülke en fazla 20 karakter olmalıdır",
                  
                    input5:"Lütfen Posta kodunuzu giriniz!",
                    input5min:"Posta kodu en az 5 karakter olmalıdır!",
                    input5max:"Posta kodu en fazla 5 karakter olmalıdır !!",
                    input6:"",
                  }
                }
              },
              form4:{
                text1: "Kart Sahibi Tam Adı",
                text2: "Kart Numarası",
                text3: "Son Kullanım Yılı",
                text4: "Son Kullanım Ayı",
                text5: "CVC",
                btn: "Satın Al",
                validation:{
                  input1:"Kart sahibi adını giriniz!",
                  input1min:"Kart sahibi adı en az 2 karakter olmalıdır",

                  input2:"Kart numarasını giriniz!",
                 
                  input3:"Son kullanma ayınızı giriniz!",
                  input3min:"Son kullanma ayı en az 2 karakter olmalıdır!",
                  input3max:"Son kullanma ayı en fazla 2 karakter olmalıdır",
                
                  input4:"Son kullanma yılınızı girin!",
                  input4min:"Son kullanma yılı en az 2 karakter olmalıdır",
                  input4max:"Son kullanma yılı en fazla 2 karakter olmalıdır",
                
                  input5:"CVC'nizi giriniz!",
                  input5min:"CVC en az 3 karakter olmalıdır!",
                  input5max:"CVC en fazla 3 karakter olmalıdır!",
                  giriş6:"",
                }
              },
              completed:{
                text1: "Alım tamamlandı!",
                text2:"Cerenin premium özelliklerinden faydalanabiliriniz.",
              },
              card:{
                text1: "Sepetim",
                text2: "Toplam"
              },
              btn: "İlerle"
            },
            pagenotfound:{},
          },
          components:{
            forms:{
              login:{
                header: "Giriş Yap",
                inputEmail: "E-posta",
                inputPwd: "Şifre",
                placeholder1:"Şifreniz",
                text1: "Beni hatırla",
                text2: "Şifremi unuttum",
                text3: "Henüz hesabın yok mu?",
                text4: "Hesap oluştur!",
                button:{
                  btnSubmit: "Giriş yap",
                  btnGoogle: "Google ile giriş yap",
                },
                validation:{
                  input1:"Lütfen e-posta adresinizi giriniz!",
                  input1format:"E-posta formatı doğru değil!",
                  input2:"Lütfen şifrenizi girin!",
                  input2min:"Şifreniz en az 8 karakter olmalıdır",
                  input2max:"Şifreniz en fazla 25 karakter olmalıdır",
                  input3:"",
                }
              },
              register:{
                header: "Kayıt Ol",
                inputEmail: "E-posta",
                inputPwd: "Şifre",
                inputName: "Tam adınız",
                inputConPwd: "Şifrenizi Doğrulayın",
                placeholder1: "Şifreniz",
                placeholder2: "Tekrar Şifreniz",
                button:{
                  btnSubmit: "Kayıt ol",
                  btnGoogle: "Google ile kayıt ol",
                },
                validation:{
                  input1:"Lütfen adınızı giriniz!",
                  input2:"Lütfen e-posta adresinizi giriniz!",
                  input2format:"E-posta formatı doğru değil!",
                  input3:"Lütfen şifrenizi girin!",
                  input3min:"Şifreniz en az 8 karakter olmalıdır",
                  input3max:"Şifreniz en fazla 25 karakter olmalıdır",
                  input4:"Lütfen şifrenizi tekrar giriniz",
                  input5:"Şifreler uyuşmuyor!",
                  input:"",
                }
              },
              forgot:{
                header: "Doğrulama Kodu Al",
                inputEmail: "E-posta",
                placeholder1: "cere@mail.com",
                button:{
                  btnSubmit: "Gönder",
                },
                inputPwd: "Şifreniz",
                inputConPwd: "Şifrenizi Doğrulayın",
                placeholder2: "Kod",
                header2: "Yeni Şifre",
                text1: "Doğrulama Kodu",
              },
              contact:{
                text1:"Adınız",
                text2:"E-posta Adresi",
                text3:"Mesajınız",
                text4:"Yeni ürünleriniz hakkıda bilgi almak istiyorum.",
                button:"Gönder",
                validation:{
                  input3:"Lütfen mesajınızı giriniz!"
                }
              }
            },
            secondHero:{
              header:{
                title: "CereMeet metaverse'de bulunan bir üretim ve iletişim aracıdır.",
                description: "CereMeet, geleneksel iletişim platformlarının yeteneklerini fotogerçekçi avatarlarla son derece gerçekçi bir 3B ortamda bir araya getirir.",
                button:{
                  btnSubmit: "Başlayın",
                }
              }
            },
            navbar:{
              main:{
                text1:"Fiyatlar",
                text2:"İletişim",
                text3: "S.S.S",
                text4: "Kılavuz",
                text5: "CereMeet",
                link: "https://pdate.ceremeet.com/ceremeetPictures/pdf/Cere_Kullanim_Kilavuzu.pdf"
              },
              right:{
                text1:"Giriş yap",
                text2:"Kayıt ol"
              },
              drawer:{
                text1: "Anasayfa",
                text2: "Fiyatlar",
                text3: "İletişim",
                text4: "S.S.S",
                text5: "Kılavuz",
                link: "https://pdate.ceremeet.com/ceremeetPictures/pdf/Cere_Kullanim_Kilavuzu.pdf"
              },
              modal1:{
                text1: "Cere üyelik seviyenizi azaltıyorsunuz.",
                text2: "Emin misiniz?",
                text3: "Üyelik İptali",
                btn1: "İptal Et",
                btn2: "Geri",
              },
              modal2:{
                text1: "Cere ürünlerini almak için",
                text2: "Giriş yapmanız gerekiyor.",
                text3: "Lütfen giriş yapın",
                btn1: "Giriş yap",
                btn2: "Geri",
              },
              profile:{
                text1: "Yükleniyor...",
                text2: "Profilinize erişmek için lütfen giriş yapın!",
                btn1: "Üyeliği yönet",
                btn2: "Şifre Yenile",
                btn3: "Çıkış yap",
                btn4: "İptal et",
                btn5: "Geri",
              },
              popover1:{
                text1 :"Seçilmiş bir paket yok!",
                btn1 :"Hemen Al",
              }
            },
            footer:{
              text1:"Gizlilik Politikası"
            },
            errors:{
              title:"Hata",
              404: "Sayfa bulunamadı.",
              1001: "Bu id'ye sahip bir adres zaten mevcut",
              1002:"Bu adresi silme yetkiniz yok",
              1003:"Bu adresi görüntüleme yetkiniz yok",
              1004:"Bu isme sahip bir adres zaten var",
              1005:"Bu başlığa sahip bir adres zaten var",
              1101:"Doğrulama hatası",
              2001:"Geçersiz eposta veya şifre",
              2002:"Hesabınız doğrulanmamış, lütfen doğrulama e-postanızı kontrol edin",
              2003:"Hatalı eposta veya şifre",
              2004:"Geçersiz eposta veya şifre",
              2006:"Eposta doğrulanamadı",
              2007:"Erişim anahtarı yenilenemedi",
              2008:"Bu epostaya sahip bir kullanıcı mevcut",
              2009:"Eposta yenileme kodunuz geçerli değil",
              3001:"Eposta gönderirken bir sorunla karşılaşıldı, lütfen tekrar deneyin",
              4001:"Bu ID ile bir toplantı bulunamadı",
              5001:"Yapay zeka kotanızı doldurdunuz",
              5002:"Diyalog limitine ulaşıldı",
              5003:"Bu ID ile bir bot bulunamadı",
              5004:"Yapay zeka cevabı alınamadı",
              5005:"Soru kullanıcı politikamızı ihlal ediyor",
              6001:"Bu ID ile bir kullanıcıya rastlanmadı",
              6002:"Kullanıcı adı daha önce alınmış",
              7001:"Giriş yapılamadı",
              7002:"Geçersiz anahtar veya kullanıcı yok",
              7003:"Geçersiz anahtar veya oturum kapatılmış",
              7004:"Geçersiz anahtar veya oturum kapatılmış",
              9001:"Zaten bu üyeliğe sahipsiniz",
              9002:"Üyeliğiniz bulunmamakta",
              100001:"Sistem hatası",
              100310:"Geçersiz token isteği.",
              100311:"Access tokenın geçerlilik süresi doldu.",
              100312:"Kimlik doğrulama hatası!",
              100300:"Üye işyeri bilgisine erişim izniniz yok.",
              200301:"Email zorunlu alandır.",
              200302:"Email bilgisi en fazla {0} karakter olmalıdır.",
              200303:"Email formatı hatalı.",
              200304:"Kimlik numarası zorunlu alandır.",
              200305:"Kimlik numarası en fazla {0} karakter olmalıdır",
              200306:"Kimlik numarası en az {0} karakter olmalıdır.",
              200310:"Geçersiz telefon numarası.",
              200311:"Telefon numarası en fazla {0} karakter olmalıdır.",
              200320:"Geçersiz Sayfalama isteği.",
              200500:"Ürün adı zorunlu alandır.",
              200501:"En az bir parametrenin gönderilmesi zorunludur.",
              200600:"Ödeme planı zorunlu alandır.",
              200601:"Fiyat bilgisi zorunlu alandır.",
              200602:"Geçersiz fiyat bilgisi.",
              200603:"Ödeme periyodu zorunlu alandır.",
              200604:"Geçersiz ödeme periyodu.",
              200605:"Döviz tipi zorunlu alandır.",
              200606:"Ödeme tipi zorunlu alandır.",
              200607:"Geçersiz ödeme tipi.",
              200608:"Geçersiz deneme süresi.",
              200610:"Referans kodu zorunlu alandır.",
              200611:"Geçersiz ödeme aralığı.",
              200700:"Müşteri adı zorunlu alandır.",
              200701:"Müşteri soyadı zorunlu alandır.",
              200702:"Müşteri telefon numarası zorunlu alandır.",
              200703:"Fatura adresi zorunlu alandır.",
              200710:"En az bir parametrenin gönderilmesi zorunludur.",
              200711:"Referans kodu zorunlu alandır.",
              200800:"Adres zorunlu alandır.",
              200801:"Adres bilgisi en az {0} karakter olmalıdır.",
              200802:"İletişim adı zorunlu alandır.",
              200803:"İletişim adı en az {0} karakter olmalıdır.",
              200804:"Şehir zorunlu alandır.",
              200805:"Şehir en az {0} karakter olmalıdır.",
              200806:"Ülke zorunlu alandır.",
              200807:"Ülke en az {0} karakter olmalıdır.",
              200808:"Posta kodu en az {0} karakter olmalıdır.",
              200900:"Referans kodu zorunlu alandır.",
              200901:"Referans kodu zorunlu alandır.",
              200902:"Geçersiz abonelik durumu.",
              201550:"Fiyat bilgisi gönderilmesi zorunludur",
              201551:"Fiyat bilgisi sıfırdan büyük olmalıdır.",
              201000:"Ürün bilgisi bulunamadı.",
              201001:"Ürün zaten var.",
              201002:"Aktif ürün bulunamadı.",
              201500:"Ödeme planı bulunamadı.",
              201501:"Ödeme planı zaten var.",
              201052:"Ödeme planı aktif değil.",
              201053:"Ödeme planı silinmek için uygun değil.",
              201054:"Ödeme planı aktif değil.",
              201100:"Müşteri bulunamadı.",
              201101:"Müşteri zaten var.",
              201102:"Müşteri aktif değil.",
              201103:"Müşterinin kartı olmalı.",
              201400:"Abonelik bulunamadı.",
              201401:"Bu abonelik aktif edilemez.",
              201402:"Bu abonelik yükseltilemez.",
              201403:"Bu abonelik iptal edilemez.",
              201404:"Abonelik aynı ödeme planına sahip.",
              201405:"Abonelik başka bir ürüne ait ödeme planına yükseltilemez.",
              201406:"Abonelik farklı ödeme sıklığına sahip ödeme plana yükseltilemez.",
              201450:"Ödeme bulunamadı.",
              200750:"Kart verisi gönderilmesi zorunludur.",
              200751:"Kartın kaydedilmesine izin verilmesi zorunludur.",
              200903:"Abonelik referens kodu zorunlu alandır.",
              200905:"Abonelik durumu kart güncelleme için uygun değil.",
              201552:"Banka kartı ile alım yapılamaz.",
              201553:"Kart müşteriye ait değil.",
              201451:"Ödeme tekrar denemek için uygun değil.",
              201600:"Ödeme formu bulunamadı.",
              201601:"Ödeme formu tamamlanmamış.",
              201700:"Yinelenen ödeme girişimi bulunamadı!",
              201900:"Döviz cinsi bulunamadı.",
            },
            successes:{
              title:"İşlem Başarılı",
              payment:{
                text1:"Profil bilgileri güncellendi.",
                text2:"Adres bilgileri güncellendi.",
                text3:"Ödeme başarıyla yapıldı.",
              },
              login:{
                text1:"Giriş yaptınız."
              },
              register:{
                text1:"Profil oluşturuldu."
              },
              forgot:{
                text1:"Yenileme kodu eposta adresinize gönderildi.",
                text2:"Şifreniz yenilendi."
              },
              contact:{
                text1:"Mesajınız gönderildi."
              }
            }
          }
        }
      }
    }
  });

export default i18n;